import { useTranslation } from '../../../context/translationContext';
import {
  UserTaskAction,
  UserTaskActionTranslated,
  UserTaskState,
  UserTaskStateTranslated,
} from '../../../types/UserTask';
import { ColDataType, TableColumn } from '../../table/DataTable.types';

export const columns: TableColumn[] = [
  {
    accessor: 'message',
    name: 'page.user-task.col-message',
    cellRenderer(e) {
      return getText(e);
    },
  },
  {
    accessor: 'createdByUserId',
    name: 'page.user-task.col-created-by-user',
  },
  {
    accessor: 'created',
    name: 'page.user-task.col-created',
    dataType: ColDataType.DATE,
  },
];

/**
 * Connect message with params
 */
const getText = (e: any) => {
  const { t } = useTranslation();
  let action = '';
  let params = '';
  if (Object.values(UserTaskState).includes(e.params)) {
    params = t(UserTaskStateTranslated[e.params as UserTaskState]);
  } else params = e.params;
  if (Object.values(UserTaskAction).includes(e.message)) {
    action = t(UserTaskActionTranslated[e.message as UserTaskAction]);
  } else action = e.message;
  const final = action.replace('{0}', params);
  return final;
};
